export const FEATURE_NAME = "alarm-schedules";
